import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react'
import { getRequestBalance, getRequestBalanceAccount } from '../../../services/balance/balanceRequest';
import { useSweetAlert } from '../../../hooks/sweetAlerts/useSweetAlert';
import { ReportBalance } from './components/ReportBalance';
import * as XLSX from 'xlsx';
import { getAllCommercialLines } from '../../../services/commercialLine/commercialLine';
import { ReportBalanceAccount } from './components/ReportBalanceAccount';
import { TabMenu } from 'primereact/tabmenu';
import { Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Row, Table, TabContent, TabPane, Button } from 'reactstrap'
import Select from 'react-select';




export const IndexReportBalance = () => {

	let _cliente = localStorage.getItem('url_helen');


	// * REPORT BALANCE
	const [filtersBalance, setFiltersBalance] = useState({
		dateStart: moment().format("YYYY-MM") + "-01",
		dateEnd: moment().endOf('month').format("YYYY-MM-DD"),
		clientId: null,
		commercialLineId: null,
		status: null

	});
	const [filtersReportBalance, setFiltersReportBalance] = useState({
		dateStart: moment().format("YYYY-MM") + "-01",
		dateEnd: moment().endOf('month').format("YYYY-MM-DD"),
		clientId: null,
		commercialLineId: null,
	});
	const [loadingBalance, setLoadingBalance] = useState(false);
	const [loadingReportBalance, setLoadingReportBalance] = useState(false);
	const [listOfCommercialLines, setListOfCommercialLines] = useState([]);
	const [listOfClients, setListOfClients] = useState([]);
	const [listOfClientsBalance, setListOfClientsBalance] = useState([]);
	const [reportBalance, setReportBalance] = useState([]);
	const [reportAccountBalance, setReportAccountBalance] = useState([]);
	const [reportAccountInitBalance, setReportAccountInitBalance] = useState([]);

	const [createSweet] = useSweetAlert();

	useEffect(() => {
		const getAllCommercialLine = async () => {
			const data = await getAllCommercialLines();
			if (data) {
				setListOfCommercialLines(data);
			}
		}

		getAllCommercialLine();
		handleGetReportBalance();
		handleGetReportBalanceAccount();
		handleGetReportAccountInitBalance();
	}, []);

	const handleGetReportBalance = async () => {
		setLoadingBalance(true);
		setReportBalance([]);
		setListOfClients([]);

		try {

			const data = await getRequestBalance(
				filtersBalance.dateStart,
				filtersBalance.dateEnd,
				filtersBalance.commercialLineId,
				filtersBalance.clientId,
				filtersBalance.status
			);

			if (data) {
				setReportBalance(data);
				setListOfClients(data?.map((item) => ({
					id: item.clientId,
					name: item.clientName,
				})));
			}
			else {
				setReportBalance([]);
				setListOfClients([]);
			}

		} catch (error) {
			createSweet("error", "error", "Opss..", "Error al obtener el balance");
		}

		setLoadingBalance(false);
	}

	// ? EXCEL
	function exportToExcelBalance(_reportBalance) {
		let _Report = [];

		let _array = _reportBalance;

		_array.forEach((client) => {
			client.reportBalanceList.forEach((_order, _index) => {
				_Report.push({
					"#": _Report.length + 1,
					CódigoCliente: client?.clientCode ?? '',
					NombreCliente: client?.clientName ?? '',
					RazonSocial: client?.clientCommercialLine ?? '',
					Factura: `${_order?.serie ?? ''} ${_order?.folio ?? ''}`,
					FechaEmisión: _order?.dateIssuing ?? '',
					Total: _order?.total ?? 0,
					NotasDeCrédito: _order?.totalOfCreditNotes ?? 0,
					TotalPagado: _order?.totalPaid ?? 0,
					TotalPendiente: _order?.totalPending ?? 0,
					DíasCrédito: `${_order?.creditDays ?? '0'} día(s)`,
					FechaPagoEstimada: _order?.dateOfPosiblePayment ?? '---',
					FechaPagos: _order?.dateOfPayments ?? '---',
					EstadoPago: _order?.statusOfPayment === "Pagado" ? 'Pagado' : (_order?.statusOfTrackingPayment ?? '---'),
					EstadoFactura: _order?.statusInvoice ?? '---',
					typePaid: client?.typePaid ?? '---'
				});
			});
		});

		const totalTotal = _Report.reduce((acc, row) => acc + (row.Total || 0), 0);
		const totalNotas = _Report.reduce((acc, row) => acc + (row.NotasDeCrédito || 0), 0);
		const totalPagado = _Report.reduce((acc, row) => acc + (row.TotalPagado || 0), 0);
		const totalPendiente = _Report.reduce((acc, row) => acc + (row.TotalPendiente || 0), 0);

		_Report.push({
			"#": '',
			CódigoCliente: '',
			NombreCliente: '',
			RazonSocial: '',
			Factura: '',
			FechaEmisión: '',
			Total: totalTotal,
			NotasDeCrédito: totalNotas,
			TotalPagado: totalPagado,
			TotalPendiente: totalPendiente,
			DíasCrédito: '',
			FechaPagoEstimada: '',
			FechaPagos: '',
			EstadoFactura: '',
			typePaid: '',
			EstadoPago: 'TOTALES'
		});

		const worksheet = XLSX.utils.json_to_sheet(_Report, {
			header: ["#", "CódigoCliente", "NombreCliente", "RazonSocial", "Factura", "FechaEmisión", "Total", "NotasDeCrédito", "TotalPagado", "TotalPendiente", "DíasCrédito", "FechaPagoEstimada", "FechaPagos", "EstadoPago", "Estado de Factura", "Generar cobro a"],
		});
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
		const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
		const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
		const fileName = 'Reporte_Balance.xlsx';

		if (typeof window !== 'undefined' && window.navigator && window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
		} else {
			const url = window.URL.createObjectURL(dataBlob);
			const link = document.createElement('a');
			link.href = url;
			link.download = fileName;
			link.click();
			window.URL.revokeObjectURL(url);
		}
	}


	const handleGetReportBalanceAccount = async (alterDateStart = null, alterDateEnd = null, isInitBalance = false) => {
		setLoadingReportBalance(true);
		setReportAccountBalance([]);
		setListOfClientsBalance([]);
		setReportAccountInitBalance([]);

		try {

			const data = await getRequestBalanceAccount(
				alterDateStart ?? filtersReportBalance.dateStart,
				alterDateEnd ?? filtersReportBalance.dateEnd,
				filtersReportBalance.commercialLineId,
				filtersReportBalance.clientId
			);

			if (data) {
				if (isInitBalance) {
					setReportAccountInitBalance(data);
					setListOfClientsBalance(data?.map((item) => ({
						id: item.clientId,
						name: item.clientName,
					})));
				}
				else {

					setReportAccountBalance(data);
					setListOfClientsBalance(data?.map((item) => ({
						id: item.clientId,
						name: item.clientName,
					})));
				}
			}
			else {
				setReportAccountBalance([]);
				setListOfClientsBalance([]);
				setReportAccountInitBalance([]);
			}

		} catch (error) {
			//createSweet("error", "error", "Opss..", "Error al obtener el balance de crédito y cobranza");
		}

		setLoadingReportBalance(false);
	};

	const handleGetReportAccountInitBalance = async () => {
		const endDate = moment(filtersReportBalance.dateStart).subtract(1, 'days').format('YYYY-MM-DD');
		const dateStart = "2024-01-01";

		setLoadingReportBalance(true);

		await handleGetReportBalanceAccount(dateStart, endDate, true);
	}

	const [activeTab, setActiveTab] = useState("1");
	const [globalFilter, setGlobalFilter] = useState("")
	const [globalFilter2, setGlobalFilter2] = useState("")
	const [expandedRows, setExpandedRows] = useState(null);
	const [expandedRows2, setExpandedRows2] = useState(null);



	const rowExpansionTemplate = (data) => {
		const columnsPerRow = 5;

		const rows = [];
		for (let i = 0; i < data.length; i += columnsPerRow) {
			rows.push(data.slice(i, i + columnsPerRow));
		}
	}

	const rowExpansionTemplate2 = (data) => {
		const columnsPerRow = 5;

		const rows = [];
		for (let i = 0; i < data.length; i += columnsPerRow) {
			rows.push(data.slice(i, i + columnsPerRow));
		}
	}


	const items =
		[
			{
				label: "Facturación",
				icon: 'pi pi-chart-line',
				command: () => setActiveTab("1")
			},
			{
				label: "Cobranza",
				icon: 'pi pi-file-pdf',
				command: () => setActiveTab("2")
			}
		];

	const number_format = (cantidad, decimals) => {
		cantidad += '';
		cantidad = parseFloat(cantidad.replace(/[^0-9\.]/g, ''));

		decimals = decimals || 0;

		if (isNaN(cantidad) || cantidad === 0) {
			return parseFloat(0).toFixed(decimals);
		}

		cantidad = '' + cantidad.toFixed(decimals);

		let cantidad_parts = cantidad.split('.'),
			regexp = /(\d+)(\d{3})/;

		while (regexp.test(cantidad_parts[0]))
			cantidad_parts[0] = cantidad_parts[0].replace(regexp, '$1' + ',' + '$2');

		return cantidad_parts.join('.');
	}

	let typeMenu = localStorage.getItem('menu') === "True";



	return (
		<div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
			<div style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "20%" }}>
				<Card style={{
					marginBottom: '15px',
					background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
					border: 'none',
					boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
				}}>
					<CardBody style={{ padding: '18px 25px' }}>
						<div className="d-flex align-items-center justify-content-between">
							<div className="d-flex align-items-center">
								<div style={{
									width: '50px',
									height: '50px',
									borderRadius: '12px',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									marginRight: '15px'
								}}>
									<img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/laboratory-External/cash-money.svg")} style={{ width: "60px", height: "60px" }} />
								</div>
								<div>
									<h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
										Reporte de Facturación
									</h4>
									<small style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13px' }}>
										<i className="fa fa-info-circle mr-1"></i>
										Análisis detallado del seguimiento de las facturas emitidas a los clientes(Facturas vencidas).
									</small>
								</div>
							</div>

						</div>
					</CardBody>
				</Card>

				<Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "1px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "113%", transformOrigin: "top left", textAlign: "center", height: "95%" }}>
					<Col sm="12" className='pt-3'>
						<Row>
							<Col sm="2" className='p-l-0 p-r-0' style={{ textAlign: "left" }}>
								<Card style={{
									boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
									border: 'none',
									height: '100%',
									borderRadius: '12px'
								}}>
									<CardHeader style={{
										background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
										color: 'white',
										padding: '15px',
										borderRadius: '12px 12px 0 0'
									}}>
										<h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
											<i className="fa fa-filter mr-2"></i>Filtros de Búsqueda
										</h6>
									</CardHeader>
									<CardBody style={{ padding: '20px' }}>
										{
											// *  ACTIONS
										}


										{
											// * ACTION TAB 1
										}
										{activeTab === "1" && (
											<>
												<FormGroup>
													<Label className='f-w-600' style={{ fontSize: '12px', marginBottom: '10px', color: '#333' }}>
														<i className="fa fa-calendar-alt mr-2" style={{ color: '#007bff' }}></i>
														Fecha de inicio
													</Label>
													<Input
														type='date'
														value={filtersBalance.dateStart}
														onChange={(e) => {
															setFiltersBalance({ ...filtersBalance, dateStart: e.target.value });
														}}
														disabled={loadingBalance}
														style={{
															borderRadius: '10px',
															border: '1px solid #ddd',
															padding: '10px',
															fontSize: '13px'
														}}
													/>
												</FormGroup>

												<FormGroup>
													<Label className='f-w-600' >
														<i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>
														Fecha de cierre
													</Label>
													<Input
														type='date'
														value={filtersBalance.dateEnd}
														onChange={(e) => {
															setFiltersBalance({ ...filtersBalance, dateEnd: e.target.value });
														}}
														disabled={loadingBalance}
														style={{
															borderRadius: '10px',
															border: '1px solid #ddd',
															padding: '10px',
															fontSize: '13px'
														}}
													/>
												</FormGroup>

												{/* <FormGroup>
													<Label >Filtrar por Razón social</Label>
													<Input
														type='select'
														value={filtersBalance.commercialLineId ?? ""}
														onChange={(e) => {
															setFiltersBalance({
																...filtersBalance,
																commercialLineId: e.target.value === "" ? null : e.target.value
															});
														}}
														disabled={loadingBalance}
														style={{
															borderRadius: '10px',
															border: '1px solid #ddd',
															padding: '10px',
															fontSize: '13px'
														}}
													>
														<option value="">Selecciona una razón social</option>
														{listOfCommercialLines?.map((item, index) => (
															<option key={index} value={item?.id_commercial_line}>
																{item?.long_name}
															</option>
														))}
													</Input>
												</FormGroup> */}

												<FormGroup>
													<Label >Filtrar por Cliente</Label>
													<Select
														options={listOfClients?.map((client) => ({
															value: client?.id,
															label: client?.name
														}))}
														value={
															filtersBalance.clientId
																? {
																	value: filtersBalance.clientId,
																	label: listOfClients.find((c) => c.id === filtersBalance.clientId)?.name
																}
																: null
														}
														onChange={(selected) => {
															setFiltersBalance({ ...filtersBalance, clientId: selected ? selected.value : null });
														}}
														placeholder="Selecciona un cliente"
														isClearable
														menuPortalTarget={document.body}
														styles={{
															control: (base) => ({
																...base,
																borderRadius: "10px",
																minHeight: "38px",
																fontSize: "13px"
															})
														}}
													/>
												</FormGroup>

												<FormGroup>
													<Label >Estado</Label>
													<Input
														type="select"
														value={filtersBalance.status ?? ""}
														onChange={(e) => {
															const val = e.target.value === "" ? null : e.target.value;
															setFiltersBalance({ ...filtersBalance, status: val });
														}}
														disabled={loadingBalance}
														style={{
															borderRadius: '10px',
															border: '1px solid #ddd',
															fontSize: '13px'
														}}
													>
														<option value="">Selecciona</option>
														<option value="1">Fiscal</option>
														<option value="0">No fiscal</option>
													</Input>
												</FormGroup>

												<br />
												<b>Acciones</b>
												<br /><br />

												<Button
													onClick={() => handleGetReportBalance()}
													color="primary"
													block
													outline
													disabled={loadingBalance}
													className="mb-3"
													onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
													onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
												>
													{loadingBalance ? (
														<>
															<i className="pi pi-spin pi-spinner"></i>&ensp;Buscando...
														</>
													) : (
														<>
															<i className="pi pi-search"></i>&ensp;Buscar
														</>
													)}
												</Button>

												<Button
													color="success"
													block
													disabled={reportBalance?.length === 0 || loadingBalance}
													onClick={() => exportToExcelBalance(reportBalance)}
													onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
													onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
												>
													<i className="pi pi-file-excel"></i>&ensp;
													Descargar
												</Button>
											</>
										)}


										{
											// * END ACTIONS TAB 1
										}

										{activeTab === "2" && (
											<>
												<FormGroup>
													<Label className='f-w-600' style={{ fontSize: '12px', marginBottom: '10px', color: '#333' }}>
														<i className="fa fa-calendar-alt mr-2" style={{ color: '#007bff' }}></i>
														Fecha inicio
													</Label>
													<Input
														type='date'
														value={filtersReportBalance.dateStart}
														onChange={(e) => {
															setFiltersReportBalance({ ...filtersReportBalance, dateStart: e.target.value });
														}}
														disabled={loadingReportBalance}
														style={{
															borderRadius: '10px',
															border: '1px solid #ddd',
															padding: '10px',
															fontSize: '13px'
														}}
													/>
												</FormGroup>

												<FormGroup>
													<Label className='f-w-600'>
														<i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>
														Fecha fin
													</Label>
													<Input
														type='date'
														value={filtersReportBalance.dateEnd}
														onChange={(e) => {
															setFiltersReportBalance({ ...filtersReportBalance, dateEnd: e.target.value });
														}}
														disabled={loadingReportBalance}
														style={{
															borderRadius: '10px',
															border: '1px solid #ddd',
															padding: '10px',
															fontSize: '13px'
														}}
													/>
												</FormGroup>

												{/* <FormGroup>
													<Label>Filtrar por Razón social</Label>
													<Input
														type='select'
														value={filter.commercialLineId ?? ""}
														onChange={(e) => {
															setFilters({
																...filter,
																commercialLineId: e.target.value === "" ? null : e.target.value
															});
														}}
														disabled={loading}
														style={{
															borderRadius: '10px',
															border: '1px solid #ddd',
															padding: '10px',
															fontSize: '13px'
														}}
													>
														<option value="">Selecciona una razón social</option>
														{commercialLines?.map((item, index) => (
															<option key={index} value={item?.id_commercial_line}>
																{item?.long_name}
															</option>
														))}
													</Input>
												</FormGroup> */}

												<FormGroup>
													<Label>Buscar</Label>
													<Input
														type="search"
														value={globalFilter2}
														onChange={(e) => setGlobalFilter2(e.target.value)}
														placeholder="Buscar..."
														style={{
															borderRadius: '10px',
															border: '1px solid #ddd',
															padding: '10px',
															fontSize: '13px'
														}}
													/>
												</FormGroup>

												<br />
												<b>Acciones</b>
												<br /><br />

												<Button
													onClick={() => {
														handleGetReportAccountInitBalance();
														handleGetReportBalanceAccount();
													}}
													color="primary"
													block
													outline
													disabled={loadingReportBalance}
													className="mb-3"
													onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
													onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
												>
													{loadingReportBalance ? (
														<>
															<i className="pi pi-spin pi-spinner"></i>&ensp;Buscando...
														</>
													) : (
														<>
															<i className="pi pi-search"></i>&ensp;Buscar
														</>
													)}
												</Button>

												<Button
													color="success"
													block
													disabled={loadingReportBalance}
													onClick={() => exportToExcelBalance()}
													onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
													onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
												>
													<i className="pi pi-file-excel"></i>&ensp;
													Descargar
												</Button>
											</>
										)}

										{
											// * END ACTIONS TAB 2
										}
										<br /> <br />
										<b>Tipo de reporte</b>
										<br /> <br />
										<Col className={`${typeMenu ? "p-l-0 p-r-0" : "p-3 p-l-0 p-r-0"}`}>
											{items.map((item, index) => {
												const isActive = parseInt(activeTab) === index + 1;

												return (
													<Col sm="12" className="p-0" key={index}>
														<Button
															onClick={() => setActiveTab((index + 1).toString())}
															color={isActive ? "danger" : "light"}
															outline={!isActive}
															className="mb-2 w-100"
															style={{
																borderRadius: '12px',
																padding: '12px',
																fontSize: '14px',
																fontWeight: 600,
																borderWidth: '2px',
																transition: 'all 0.2s ease',
																backgroundColor: isActive ? '#3b82f6' : '',
																color: isActive ? '#fff' : '#333',

																// 🔥 mantiene todo uniforme
																minHeight: '50px',
																display: 'flex',
																alignItems: 'center',
																justifyContent: 'flex-start', // 👈 se ve más tipo menú
																textAlign: 'left',
																paddingLeft: '15px'
															}}
															onMouseEnter={(e) => {
																e.currentTarget.style.transform = 'translateY(-2px)';
															}}
															onMouseLeave={(e) => {
																e.currentTarget.style.transform = 'translateY(0)';
															}}
														>
															{item.label}
														</Button>
													</Col>
												);
											})}
										</Col>
									</CardBody>
								</Card>
							</Col>

							<Col sm="10">
								<div style={{
									marginTop: '1px',
								}}>
									<Col sm="12" className='p-l-0 p-r-0' >
										{activeTab === "1" && (
											<>
												{
													<ReportBalance
														filter={filtersBalance}
														setFilters={setFiltersBalance}
														commercialLines={listOfCommercialLines}
														listOfClients={listOfClients}
														reportBalance={reportBalance}
														loading={loadingBalance}
														handleGetReportBalance={handleGetReportBalance}
														exportToExcelBalance={exportToExcelBalance}
														setGlobalFilter={setGlobalFilter}
														globalFilter={globalFilter}
														number_format={number_format}
														expandedRows={expandedRows}
														setExpandedRows={setExpandedRows}
														rowExpansionTemplate={rowExpansionTemplate}
													/>
												}
											</>
										)}


										{activeTab === "2" && (
											<>
												{
													<ReportBalanceAccount
														filter={filtersReportBalance}
														setFilters={setFiltersReportBalance}
														commercialLines={listOfCommercialLines}
														listOfClients={listOfClientsBalance}
														reportAccountBalance={reportAccountBalance}
														loading={loadingReportBalance}
														handleGetReportAccountInitBalance={handleGetReportAccountInitBalance}
														handleGetReportBalanceAccount={handleGetReportBalanceAccount}
														initBalance={reportAccountInitBalance}
														setGlobalFilter2={setGlobalFilter2}
														globalFilter2={globalFilter2}
														number_format={number_format}
														expandedRows2={expandedRows2}
														setExpandedRows2={setExpandedRows2}
														rowExpansionTemplate2={rowExpansionTemplate2}
														urlClient={_cliente}
													/>
												}
											</>
										)}
									</Col>


								</div>
							</Col>


						</Row>
					</Col>
				</Card>




			</div >






			{/* <div className='container-global-zoom' >
			<TabMenu 
			    model={items} 
				activeIndex={parseInt(activeTab) - 1} 
				onTabChange={(e) => setActiveTab((e.index + 1).toString())} 
				className={`${typeMenu ? "" : "p-3"}`}
			/>
			<TabContent activeTab={activeTab} className="mt-3">
				{activeTab === "1" && (
					<>
					{
						<ReportBalance
							filter={filtersBalance}
							setFilters={setFiltersBalance}
							commercialLines={listOfCommercialLines}
							listOfClients={listOfClients}
							reportBalance={reportBalance}
							loading={loadingBalance}
							handleGetReportBalance={handleGetReportBalance}
							exportToExcelBalance={exportToExcelBalance}
							setGlobalFilter={setGlobalFilter}
							globalFilter={globalFilter}
							number_format={number_format}
							expandedRows={expandedRows}
							setExpandedRows={setExpandedRows}
							rowExpansionTemplate={rowExpansionTemplate}
						/>
					}
					</>
				)}
				{activeTab === "2" && (
					<>
					{
						<ReportBalanceAccount
							filter={filtersReportBalance}
							setFilters={setFiltersReportBalance}
							commercialLines={listOfCommercialLines}
							listOfClients={listOfClientsBalance}
							reportAccountBalance={reportAccountBalance}
							loading={loadingReportBalance}
							handleGetReportAccountInitBalance={handleGetReportAccountInitBalance}
							handleGetReportBalanceAccount={handleGetReportBalanceAccount}
							initBalance={reportAccountInitBalance}
							setGlobalFilter2={setGlobalFilter2}
							globalFilter2={globalFilter2}
							number_format={number_format}
							expandedRows2={expandedRows2}
							setExpandedRows2={setExpandedRows2}
							rowExpansionTemplate2={rowExpansionTemplate2}	
							urlClient={_cliente}
						/>
					}
					</>
				)}
			</TabContent>
			</div> */}
		</div >
	)
}
